import { userId, spaceId } from "../url-parameters.js";

const SPACE_ACTIVITIES_URL = "https://spaceactivities-rqfgqadjxa-ez.a.run.app";
const DEFAULT_SPACE_ID = "dalmwo";

// Must match Firebase secret ZEP_APP_SECRET
const W2L_APP_SECRET = "yOL7/Xl3FsIHGYihibY+thG0MlTeezrqx3pONsvCODQ=";

export function getActivityDescription(activity) {
  if (!activity) return "نشاط";
  return activity.activityDescription || activity.activityName || "نشاط";
}

export function normalizeCategory(category) {
  if (category === "game") return "entertainment";
  if (category === "work") return "productivity";
  return category === "productivity" ? "productivity" : "entertainment";
}

export function getCategoryLabel(category) {
  return normalizeCategory(category) === "productivity" ? "انتاجية" : "ترفيهية";
}

export function getActivityStartMs(activity) {
  if (!activity || !activity.scheduledAt) return 0;
  const startMs = new Date(activity.scheduledAt).getTime();
  return Number.isNaN(startMs) ? 0 : startMs;
}

export function formatTimeUntilStart(remainingMs) {
  if (remainingMs <= 0) return "";

  if (remainingMs < 60000) {
    return "يبدأ خلال أقل من دقيقة";
  }

  const totalMinutes = Math.ceil(remainingMs / 60000);
  const days = Math.floor(totalMinutes / (60 * 24));
  const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
  const minutes = totalMinutes % 60;
  const parts = [];

  if (days > 0) {
    parts.push(days === 1 ? "يوم واحد" : days === 2 ? "يومين" : days + " أيام");
  }
  if (hours > 0) {
    parts.push(hours === 1 ? "ساعة واحدة" : hours === 2 ? "ساعتين" : hours + " ساعات");
  }
  if (minutes > 0 && days === 0) {
    parts.push(
      minutes === 1 ? "دقيقة واحدة" : minutes === 2 ? "دقيقتين" : minutes + " دقائق"
    );
  }

  return "يبدأ خلال " + parts.join(" و ");
}

export function formatActivityWhen(activity, nowMs = Date.now()) {
  const startMs = getActivityStartMs(activity);
  if (!startMs) return "";

  const durationMinutes = Number(activity.durationMinutes) || 60;
  const endMs = startMs + durationMinutes * 60 * 1000;

  if (startMs <= nowMs && endMs > nowMs) {
    return "جاري الآن";
  }

  if (startMs > nowMs) {
    return formatTimeUntilStart(startMs - nowMs);
  }

  return "";
}

export function formatActivityDateTime(activity) {
  const startMs = getActivityStartMs(activity);
  if (!startMs) return "";

  try {
    return new Intl.DateTimeFormat("ar", {
      weekday: "long",
      day: "numeric",
      month: "long",
      hour: "numeric",
      minute: "2-digit",
    }).format(new Date(startMs));
  } catch {
    return new Date(startMs).toLocaleString("ar");
  }
}

/** Soonest active/upcoming activity from the space list. */
export function pickNextActivity(activities, nowMs = Date.now()) {
  if (!Array.isArray(activities) || activities.length === 0) return null;

  const ranked = activities
    .map(function (activity) {
      const startMs = getActivityStartMs(activity);
      if (!startMs) return null;
      const durationMinutes = Number(activity.durationMinutes) || 60;
      const endMs = startMs + durationMinutes * 60 * 1000;
      if (endMs <= nowMs) return null;
      return { activity, startMs };
    })
    .filter(Boolean)
    .sort(function (a, b) {
      return a.startMs - b.startMs;
    });

  return ranked.length ? ranked[0].activity : null;
}

export async function fetchNextActivity() {
  const resolvedSpaceId = spaceId || DEFAULT_SPACE_ID;
  if (!resolvedSpaceId) return null;

  const res = await fetch(SPACE_ACTIVITIES_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-W2L-Secret": W2L_APP_SECRET,
    },
    body: JSON.stringify({
      spaceId: resolvedSpaceId,
      userId: userId || undefined,
    }),
  });

  const text = await res.text();
  let data = {};
  try {
    data = JSON.parse(text);
  } catch {
    return null;
  }

  return pickNextActivity(data.activities || []);
}
